import type { AnalyticName } from './types';

interface AnalyticPropertyConfig {
  name: AnalyticName;
  intervalKey: string;
  dailyKey?: string;
  isPercentage?: boolean;
  unit?: string;
  tooltip: string;
}

export const ANALYTIC_PROPERTIES: Record<string, AnalyticPropertyConfig> = {
  ExpectedResidualQuantity: {
    name: 'Residual Qty',
    intervalKey: 'ExpectedResidualQuantity',
    tooltip: 'The predicted Residual quantity to be left un-filled at the end of the order',
  },
  IntervalSpreadBps: {
    name: 'Spread',
    intervalKey: 'IntervalSpreadBps',
    dailyKey: 'DailySpreadBps',
    unit: 'BPS',
    tooltip: 'The average of the intraday predicted bid-ask spreads',
  },
  IntervalVolume: {
    name: 'Volume',
    intervalKey: 'IntervalVolume',
    dailyKey: 'AverageDailyVolume',
    tooltip: 'Predicted number of coins to be traded',
  },
  PredictedParticipationRatePct: {
    name: 'Participation rate',
    intervalKey: 'PredictedParticipationRatePct',
    dailyKey: 'OrderAverageDailyVolumePct',
    isPercentage: true,
    tooltip:
      'Percentage of the order qty against the predicted Volume (INTERVAL) and against the total Average Daily Volume (DAILY)',
  },
  IntervalVolatilityBps: {
    name: 'Volatility',
    intervalKey: 'IntervalVolatilityBps',
    dailyKey: 'DailyVolatilityBps',
    unit: 'BPS',
    tooltip: 'Predicted Volatility in the price, daily scaled',
  },
} as const;
